import React, {ReactNode} from 'react';

import {Link} from 'react-router-dom';

import cn from 'classnames';

import styles from './MonitorStatus.module.scss';

interface MonitorStatusProps {
    text: ReactNode;
    counter: string;
    className: string;
    icon: ReactNode;
    link: string;
    color: string
    textColor: string;
}

const MonitorStatus: React.FC<MonitorStatusProps> = ({className, icon, link, text, counter, color, textColor}) => {
    return (
        <Link to={link}>
            <div className={className}>
                <div className={cn(styles.icon, color)}>{icon}</div>
                <div className={styles.content}>
                    <span className={styles.counter}>{counter}</span>
                    <span className={cn(styles.text, textColor)}>{text}</span>
                </div>
            </div>
        </Link>
    );
};

export default MonitorStatus;